export enum DateFormat {
  MDY,
  DMY,
}

export const Locale = {
  EN_US: 'en-US',
};

export const formatMonthAndDay = (text: string): string => {
  const parsedText = parseInt(text);
  if (!isNaN(parsedText) && parsedText < 10) {
    text = '0' + parseInt(text).toString();
  }
  return text;
};
